import { RequestParameters, CrossSellingRanking } from "./interfaces"
import { httpGetRequest } from "clients/phronesisClient"
import { CROSS_SELLING_RANKING_ENDPOINT } from "./constants"

const NUMBER_RETRIES = 0

export const getCrossSellingRankingInformation = async (
	filters: RequestParameters
): Promise<CrossSellingRanking> => {
	return httpGetRequest<CrossSellingRanking>(
		CROSS_SELLING_RANKING_ENDPOINT,
		filters,
		undefined,
		undefined,
		undefined,
		NUMBER_RETRIES
	)
}
